(ns common.resource.query.adserver-account
  (:require [common.db.effects.http :refer [jsonify]]
            [common.queries.http :as qhttp]))

(defn- sort->query-param [{:keys [field sort]}]
  (if (and field sort)
    (str (when (= sort "desc") "-")
         (name field))
    ""))

(defn adserver-accounts-query [{:keys [agency-id]}]
  #js {:queryKey #js ["adserver-accounts" agency-id]
       :queryFn (fn [_ctx]
                  (qhttp/get
                   (qhttp/render :api/agency-adserver-accounts
                                 {:agency-id agency-id}
                                 {:embed (jsonify ["adserver"])})))
       :enabled (boolean agency-id)})

(defn adserver-accounts-paginated-query [{:keys [agency-id term page-size sort]}]
  (let [sort-query-param (sort->query-param sort)
        filters (when (seq term)
                  (jsonify [["has" "name" term]]))]
    #js {:queryKey #js ["adserver-accounts-paginated" agency-id term page-size sort-query-param]
         :queryFn (fn [^js ctx]
                    (qhttp/get
                     (qhttp/render :api/agency-adserver-accounts
                                   {:agency-id agency-id}
                                   (cond-> {:pagesize page-size
                                            :embed (jsonify ["adserver"])
                                            :page (.-pageParam ctx)}
                                     (seq sort-query-param) (assoc :sort sort-query-param)
                                     filters (assoc :filters filters)))))
         :initialPageParam 1
         :getNextPageParam (fn [_ pages]
                             (inc (count pages)))
         :enabled (boolean agency-id)}))
